<template>
  <div class="tag-wrapper" @mouseleave="showTable = false">
    <span
      v-if="client.ended"
      class="label tag-waiting table-tag-content"
      @mouseenter="showTable = true"
      ><span
        >Ended<a @click.prevent="$emit('delete')"
          ><span
            v-if="showRemove"
            class="fas fa-times remove-tag-icon"
          ></span></a
      ></span>
    </span>
    <div
      v-if="showTable"
      class="tag-table pop-up-for-tags"
      @mouseenter="showTable = false"
    >
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr v-for="item in client.client_ended" :key="item.id">
              <td>{{ formatDateTable(item.updated_at) }}</td>
              <td>{{ item.updated_at | shortTime }}</td>
              <td>{{ item.user.full_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Ended",
  props: {
    client: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showTable: false
    };
  },
  methods: {
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    }
  }
};
</script>

<style scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-waiting {
  background-color: #008b00;
  /*font-size: 12px;*/
  /*margin: 1px;*/
  /*!*padding: 3px;*!*/
  /*cursor: pointer;*/
  /*!* line-height: 2;*!*/
  /*animation: flash linear 1s;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  bottom: 24px;

  border: solid 1px #008b00;
}

.table-responsive {
  /*margin-bottom: -18px;*/
  border-radius: 5px;
}

.remove-tag-icon {
  color: white;
  cursor: pointer;
  margin-left: 5px;
}

.remove-tag-icon:hover {
  color: #f44336;
}
.label {
  padding: 2px !important;
}
.table {
  margin-bottom: unset;
}
.table-tag-content {
  margin-top: 3px;
  min-width: 49px !important;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
</style>
